import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material.module';
import { SpinnerComponent } from '../../../shared/spinner/spinner.component';
import { ChatMessageComponent } from '../../../chat/chat-message/chat-message.component';
import { NoraChatStatisticsService } from '../../../services/nora-statistics.service';
import { ChatMessage } from '../../../models/chat.models';

export interface ConversationDialogData {
  sessionId: string;
  userDisplayName: string;
}

@Component({
  selector: 'app-conversation-dialog',
  templateUrl: './conversation-dialog.component.html',
  styleUrls: ['./conversation-dialog.component.scss'],
  imports: [CommonModule, MaterialModule, SpinnerComponent, ChatMessageComponent]
})
export class ConversationDialogComponent implements OnInit {
  messages: ChatMessage[] = [];
  loading = true;
  error: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<ConversationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConversationDialogData,
    private statisticsService: NoraChatStatisticsService
  ) {}

  ngOnInit(): void {
    this.statisticsService.getSessionMessages(this.data.sessionId).subscribe({
      next: (messages) => {
        this.messages = messages;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error loading conversation:', err);
        this.error = 'Failed to load conversation';
        this.loading = false;
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
